import React from 'react';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';

import PropTypes from 'prop-types';

import { CopyToClipboardButton } from 'ui-components/components/copy-to-clipboard-button/copy-to-clipboard-button';
import { EmailAddressLink } from 'ui-components/components/email-adress-link/email-address-link';

import { ContactInfoField } from './contact-info-field';
import { messages } from './messages';

import style from './contact-info-field.module.css';

export const EmailAddress = ({ emailAddress, mailTo }) => {
  return (
    <ContactInfoField icon={faEnvelope}>
      <EmailAddressLink className={style['contact-info-field-value']} emailAddress={emailAddress} mailTo={mailTo} />
      <CopyToClipboardButton
        className={style['copy-button']}
        textToCopy={emailAddress}
        tooltipMessageDescriptor={messages.emailAddressIconLabel}
      />
    </ContactInfoField>
  );
};

EmailAddress.propTypes = {
  emailAddress: PropTypes.string.isRequired,
  mailTo: PropTypes.string,
};
